import React from "react";

const SocketContext = React.createContext<SocketIOClient.Socket | null>(null);
SocketContext.displayName = "Socket";

export default SocketContext;
